import { render, staticRenderFns } from "./view.vue?vue&type=template&id=ca9fa00a&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=ca9fa00a&prod&lang=less&scoped=true"
import style1 from "./view.vue?vue&type=style&index=1&id=ca9fa00a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9fa00a",
  null
  
)

export default component.exports